import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-env-indicator',
    templateUrl: './env-indicator.component.html',
    styleUrls: ['./env-indicator.component.scss'],
    standalone: false
})
export class EnvIndicatorComponent {

    public production: boolean;
    public minimized: boolean;
    public minimizing: boolean;

    get label(): string {
        return environment.name;
    }

    constructor() {
        this.production = !environment.sandbox;
    }

    minimize(): void {
        this.minimizing = true;

        setTimeout(() => {
            this.minimized = true;
        }, 250);
    }

}
